import lodashGet from 'lodash/get';
import { api as masterApi } from '@/api/api';
import { apis } from '@/config';
export class DexieUpdateargsInterceptor {
    constructor(interceptors) {
        this.systemApi = masterApi.getSystemApi();
        const [requestInterceptor] = interceptors;
        requestInterceptor.use({
            namespace: apis.dbInterfaceApiImpl,
            resolve: async (config) => {
                if (config.namespace !== apis.dbInterfaceApiImpl) {
                    return config;
                }
                const _account = lodashGet(config, 'args[0]._dbAccount', '') || lodashGet(config, 'args[0]._account', '');
                if (typeof _account === 'string' && _account.length > 0 && _account.includes('@')) {
                    const [dbRefer] = config.args;
                    dbRefer._dbAccount = this.systemApi.md5(_account, true);
                    return config;
                }
                if (!window.isAccountBg) {
                    return config;
                }
                const [dbRefer] = config.args;
                dbRefer._dbAccount = lodashGet(this.systemApi.getCurrentUser(), 'accountMd5', '');
                return config;
            },
        });
    }
    eject() { }
}
